// svg转base64图片，参考：https://github.com/scriptex/svg64

import tinycolor from 'tinycolor2'

const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
const PREFIX = 'data:image/svg+xml;base64,'

const utf8Encode = (string: string) => {
  string = string.replace(/\r\n/g, '\n')
  let utftext = ''

  for (let n = 0; n < string.length; n++) {
    const c = string.charCodeAt(n)

    if (c < 128) {
      utftext += String.fromCharCode(c)
    }
    else if (c > 127 && c < 2048) {
      utftext += String.fromCharCode((c >> 6) | 192)
      utftext += String.fromCharCode((c & 63) | 128)
    }
    else {
      utftext += String.fromCharCode((c >> 12) | 224)
      utftext += String.fromCharCode(((c >> 6) & 63) | 128)
      utftext += String.fromCharCode((c & 63) | 128)
    }
  }

  return utftext
}

const encode = (input: string) => {
  let output = ''
  let chr1, chr2, chr3, enc1, enc2, enc3, enc4
  let i = 0
  input = utf8Encode(input)
  while (i < input.length) {
    chr1 = input.charCodeAt(i++)
    chr2 = input.charCodeAt(i++)
    chr3 = input.charCodeAt(i++)
    enc1 = chr1 >> 2
    enc2 = ((chr1 & 3) << 4) | (chr2 >> 4)
    enc3 = ((chr2 & 15) << 2) | (chr3 >> 6)
    enc4 = chr3 & 63
    if (isNaN(chr2)) enc3 = enc4 = 64
    else if (isNaN(chr3)) enc4 = 64
    output = output + characters.charAt(enc1) + characters.charAt(enc2) + characters.charAt(enc3) + characters.charAt(enc4)
  }
  return output
}

/**
 * PowerPoint 无法正确解析 SVG 中的 8 位十六进制色（#RRGGBBAA），会渲染为黑色。
 * 导出前将其转为 fill-opacity / rgba 等兼容格式。
 */
const normalizeSvgColorsForExport = (svg: string): string => {
  const splitHexAlpha = (color: string): { color: string; opacity?: number } | null => {
    if (!/^#([0-9a-fA-F]{8}|[0-9a-fA-F]{4})$/.test(color)) return null
    const tc = tinycolor(color)
    if (!tc.isValid()) return null
    const alpha = tc.getAlpha()
    if (alpha >= 1) return { color: tc.toHexString() }
    return { color: tc.setAlpha(1).toHexString(), opacity: alpha }
  }

  svg = svg.replace(
    /(fill|stroke|stop-color)=(["'])(#[0-9a-fA-F]{8})\2/gi,
    (_m, attr: string, quote: string, color: string) => {
      const split = splitHexAlpha(color)
      if (!split) return _m
      if (split.opacity === undefined) return `${attr}=${quote}${split.color}${quote}`
      const opacityAttr = attr.toLowerCase() === 'stop-color' ? 'stop-opacity' : `${attr.toLowerCase()}-opacity`
      return `${attr}=${quote}${split.color}${quote} ${opacityAttr}="${split.opacity}"`
    },
  )

  svg = svg.replace(
    /(fill|stroke|stop-color)\s*:\s*(#[0-9a-fA-F]{8})\b/gi,
    (_m, attr: string, color: string) => {
      const tc = tinycolor(color)
      if (!tc.isValid()) return _m
      const { r, g, b, a } = tc.toRgb()
      return `${attr}: rgba(${r}, ${g}, ${b}, ${a})`
    },
  )

  return svg
}

export const svg2Base64 = (element: Element) => {
  if (!(element instanceof Element)) {
    throw new TypeError('svg2Base64: 参数必须是 DOM Element')
  }
  const XMLS = new XMLSerializer()
  const svg = normalizeSvgColorsForExport(XMLS.serializeToString(element))

  return PREFIX + encode(svg)
}